export default "__VITE_ASSET__BEkUnml3__"